import { randomPassword } from "secure-random-password";

export const generateNewPassword = (): string => {
  return randomPassword({
    length: 8,
    characters: [
      { characters: "ABCDEFGHIJKLMNOPQRSTUVWXYZ", exactly: 1 },
      { characters: "!@#$%^&*()_+[]{}|;:,.<>?/", exactly: 1 },
      { characters: "0123456789", exactly: 1 },
      { characters: "abcdefghijklmnopqrstuvwxyz" },
    ],
  });
};
